import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updateSpotlightSplitStatus = {
  name: "updateSpotlightSplitStatus" as const,
  input: z.object({ splitId: zExt.objectId(), active: z.boolean() }),
  output: z.object({ success: z.boolean() }),
};
